"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = require("react");
var MainHeaderWithBackLink_1 = require("../../../common/components/presentation/MainHeader/MainHeaderWithBackLink");
var ConfirmationReserveOnline_1 = require("./ConfirmationReserveOnline");
var ConfirmationReserveOnlineScreen = function () {
    var activateMainTitle = core_1.useTheme().checkoutLite.common.activateMainTitle;
    var translationId = !!activateMainTitle ? 'confirmation.mainTitle' : 'journeyType.checkoutReserveOnline';
    return (<>
      <MainHeaderWithBackLink_1.default titleTranslation={translationId} theme="simple"/>
      <ConfirmationReserveOnline_1.default />
    </>);
};
exports.default = ConfirmationReserveOnlineScreen;
